import React, { useEffect, useState } from "react";
import {
  Button,
  Grid,
  Typography,
  TableBody,
  Table,
  TableContainer,
  Chip,
  TablePagination,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import NumberFormat from "react-number-format";
import styles from "../../../../styles/global-styles.js";
import StyledTableCell from "../../../../styles/tableCell.jsx";
import StyleTableRow from "../../../../styles/styleTableRow";
import { Link } from "react-router-dom";
import { ProductService } from "../../../../services/product.service";
import { connect } from "react-redux";
import { actions } from "../../../../redux/actions/alert.js";
import {
  changeRowsPerPage,
  filterCashCardByBarCode,
} from "../../../../_utils/utils.js";
import {
  addAvailabilityToProducts,
  cashCardsAvailable,
} from "../utils.inventory.js";
import TableHeadCashCardProduct from "../../../stateless/headTables/TableHeadCashCardProduct.jsx";

const useStyles = makeStyles((theme) => ({
  title: styles.title,
  rightButton: styles.buttonRightHeader,
  label: styles.label,
  table: {
    minWidth: 700,
  },
  header: styles.header,
  row: styles.rowHover,
  chip: styles.chip,
  subtitle: styles.subtitle,
  lowExistence: styles.lowExistence,
  mediumExistence: styles.mediumExistence,
  highExistence: styles.highExistence,
}));

const CashCardInventory = ({
  history: {
    push,
    location: { search },
  },
  addAlert,
  detailAlert,
}) => {
  const classes = useStyles();
  const theme = useTheme();

  const [productArray, setProductArray] = React.useState([]);
  const [availablesInStore, setAvailablesInStore] = useState({});
  const [availablesInSite, setAvailablesInSite] = useState({});
  const [getQuantity, setQuantity] = useState(false);
  const [productsAvailable, setProductsAvailable] = useState(false);
  /** Pagination */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await ProductService.getProductByCashCard();
        console.log("cash card product", data);
        setProductArray(filterCashCardByBarCode(data));
        getCardCashProductsAvailable(data);
      } catch (err) {
        console.log(err);
        addAlert({ showAlert: true });
        detailAlert({
          severity: "error",
          message: err.msgs || "Error al procesar tu solicitud",
        });
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (getQuantity) {
      const productsWithAvailability = addAvailabilityToProducts(
        productArray,
        availablesInStore,
        availablesInSite
      );
      setProductArray(productsWithAvailability);
      setProductsAvailable(true);
    }
  }, [getQuantity]);

  const getCardCashProductsAvailable = async (cardCashArray) => {
    try {
      const { availableInStore, availableInSite } = await cashCardsAvailable(
        cardCashArray
      );
      setAvailablesInStore(availableInStore);
      setAvailablesInSite(availableInSite);
      setQuantity(true);
    } catch (error) {
      console.log("error", error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: error.msg
          ? error.msg
          : "Error al obtener la disponibilidad de productos",
      });
    }
  };

  const goToUrl = (url, product) => {
    console.log("product", product);
    const {
      cash_card: { cardCatalogueId },
      productTypeId,
    } = product;
    console.log("card product", { cardCatalogueId });
    return push(url, { cardCatalogueId, productTypeId });
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  return (
    <>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item>
          <Typography variant="h4" component="h4" className={classes.title}>
            Inventario tarjetas de saldo
          </Typography>
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        spacing={4}
        style={{ marginTop: 50 }}
      >
        <Grid item>
          <Link
            to={{
              pathname: `../inventario/captura`,
              state: { tabOption: 4 },
            }}
            className={classes.link}
          >
            <Button
              className={classes.rightButton}
              variant="contained"
              color="primary"
              endIcon={<AddCircleIcon color="secondary"></AddCircleIcon>}
            >
              Agregar inventario
            </Button>
          </Link>
        </Grid>
      </Grid>

      <Grid style={{ marginTop: theme.spacing(3) }}>
        <TableContainer>
          <Table className={classes.table} aria-label="customized table">
            <TableHeadCashCardProduct />
            <TableBody>
              {productsAvailable &&
                productArray
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, i) => (
                    <StyleTableRow
                      key={i}
                      className={classes.row}
                      onClick={() =>
                        goToUrl("/dashboard/inventario/detalle-producto", row)
                      }
                    >
                      <StyledTableCell align="center">
                        {row.cash_card?.card_catalogue.name || ""}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.cash_card?.card_catalogue.barCode || ""}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <NumberFormat
                          value={row.cash_card?.card_catalogue.amount || 0}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Chip
                          label={row.availablesInStore}
                          className={
                            row.availablesInStore <= 3
                              ? classes.lowExistence
                              : row.availablesInStore <= 7
                              ? classes.mediumExistence
                              : classes.highExistence
                          }
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Chip
                          label={row.availablesInSite}
                          className={
                            row.availablesInSite <= 3
                              ? classes.lowExistence
                              : row.availablesInSite <= 7
                              ? classes.mediumExistence
                              : classes.highExistence
                          }
                        />
                      </StyledTableCell>
                    </StyleTableRow>
                  ))}
            </TableBody>
          </Table>
          {!productArray.length && (
            <Typography
              variant="h6"
              component="h4"
              style={{ marginTop: 50 }}
              className={classes.subtitle}
            >
              No hay productos en el inventario
            </Typography>
          )}
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={productArray.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={(event) => {
            const { rowsPerPage, page } = changeRowsPerPage(event);
            setRowsPerPage(rowsPerPage);
            setPage(page);
          }}
        />
      </Grid>
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(CashCardInventory);
